import React from 'react';
import { Typography, Box } from '@mui/material';

export function Footer() {
    return (
       <Box sx={{ mt :2 }}>
          <Typography variant="body2" color="text.secondary" align="center">
             {'© '}
             {new Date().getFullYear()}
             {' Purchase Paradise'}
          </Typography>
       </Box>
    );
 }